import Types from "./Types";

export const getAllTagsRequest = (body) => ({
  type: Types.GET_SUPERADMIN_TAGS_REQUEST,
  payload: body,
});

export const getAllTagsSuccess = (data) => ({
  type: Types.GET_SUPERADMIN_TAGS_SUCCESS,
  payload: data,
});

export const getAllTagsFail = () => ({
  type: Types.GET_SUPERADMIN_TAGS_FAIL,
});

export const editTagRequest = (formData) => ({
  type: Types.EDIT_SUPERADMIN_TAG_REQUEST,
  payload: formData,
});

export const editTagSuccess = (data) => ({
  type: Types.EDIT_SUPERADMIN_TAG_SUCCESS,
  payload: data,
});

export const editTagFail = () => ({
  type: Types.EDIT_SUPERADMIN_TAG_FAIL,
});

//LOADING
export const addTagLoading = (isLoading) => ({
  type: Types.ADD_SUPERADMIN_TAGS_LOADING,
  payload: isLoading,
});

// Create Tag
export const createTagRequest = (formData, action) => ({
  type: Types.CREATE_SUPERADMIN_TAG_REQUEST,
  payload: formData,
  action: action,
});

export const createTagSuccess = ({ data }) => ({
  type: Types.CREATE_SUPERADMIN_TAG_SUCCESS,
  payload: {
    data,
  },
});

export const createTagFail = () => ({
  type: Types.CREATE_SUPERADMIN_TAG_FAIL,
});

export const deleteTagRequest = (id) => ({
  type: Types.DELETE_SUPERADMIN_TAG_REQUEST,
  payload: id,
});

export const deleteTagSuccess = (id) => ({
  type: Types.DELETE_SUPERADMIN_TAG_SUCCESS,
  payload: id,
});

export const deleteTagFail = () => ({
  type: Types.DELETE_SUPERADMIN_TAG_FAIL,
});

export const enableTagRequest = (formData) => ({
  type: Types.ENABLE_SUPERADMIN_TAG_REQUEST,
  payload: formData,
});

export const enableTagSuccess = (data) => ({
  type: Types.ENABLE_SUPERADMIN_TAG_SUCCESS,
  payload: data,
});

export const enableTagFail = () => ({
  type: Types.ENABLE_SUPERADMIN_TAG_FAIL,
});

export const togglePractice = (id) => ({
  type: Types.TOGGLE_PRACTICE_TAG_REQUEST,
  payload: id,
});

export const togglePracticeSuccess = (data) => ({
  type: Types.TOGGLE_PRACTICE_TAG_SUCCESS,
  payload: data,
});

export const togglePracticeFail = () => ({
  type: Types.TOGGLE_PRACTICE_TAG_FAIL,
});